<template>
  <v-tooltip top>
    <template v-slot:activator='{ on }'>
      <v-chip class='mr-2' label :xSmall='small' :color='color' v-on='on' :outlined='!posted'>
        <v-icon left :small='small'>
          <template v-slot:default v-if='posted'>mdi-stamper</template>
          <template v-slot:default v-else>mdi-stamper</template>
        </v-icon>
        <span>
          <span v-if='posted'>POSTED</span>
          <span v-else>NOT POSTED</span>
        </span>
      </v-chip>
    </template>
    <span v-if='posted'>{{ postedTooltip }}</span>
    <span v-else>{{ notPostedTooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'posted-chip',
  props: {
    small: {
      required: false,
      type: Boolean,
      defualt: false
    },
    mini: {
      required: false,
      type: Boolean,
      defualt: false
    },
    posted: {
      required: false,
      type: Boolean,
      default: false
    },
    postedTooltip: {
      required: false,
      default: 'Recorded in the accounting records'
    },
    notPostedTooltip: {
      required: false,
      default: 'NOT recorded in the accounting records'
    }
  },
  computed: {
    color () {
      if (this.posted) {
        return 'info'
      }
      return 'grey'
    }
  }
}
</script>
